import { Injectable } from '@angular/core';
import { GamerFormData } from '../models/gamer-form-data';

@Injectable({
  providedIn: 'root',
})
export class ArenaProDataService {
  public gamerFormData: GamerFormData;
  public selectedData: any[]=[];
  ProfileExist: boolean;
  gamerId: String;
  email: String;
  confirmEmail: String;
  constructor() {
  }
  setGamerId(G){
    this.gamerId = G;
  }
  getGamerId(){
   return this.gamerId 
  }
  
  setEmail(E){
    this.email = E;
  }
  getEmail(){
   return this.email 
  }
  
  setConfirmEmail(C){
    this.confirmEmail = C;
  }
  getConfirmEmail(){
   return this.confirmEmail 
  }
}